import { parseUtcMs } from "@/shared/utils/datetime/public";

const SUCCEEDED_STATUSES = new Set(["succeeded"]);
const FAILED_STATUSES = new Set(["failed", "lost", "cancelled"]);

export function isSucceededEvalStatus(status: string): boolean {
  return SUCCEEDED_STATUSES.has(status);
}

export function isFailedEvalStatus(status: string): boolean {
  return FAILED_STATUSES.has(status);
}

/** Evaluation 실행 시간 계산에 필요한 최소 계약. */
export type TimedEvaluationRun = {
  started_at: string | null;
  finished_at: string | null;
};

/** 시작과 종료가 모두 유효한 Evaluation 실행의 벽시계 시간을 초로 계산한다. */
export function runDurationSeconds(run: TimedEvaluationRun): number | null {
  const start = parseUtcMs(run.started_at);
  const finish = parseUtcMs(run.finished_at);
  if (start === null || finish === null || finish < start) return null;
  return Math.round((finish - start) / 1000);
}
